async.push(["ready", function() {
    // Initialise the Ajax funxctions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    initAjaxJS();
}]);

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
window.initAjaxJS = function initAjaxJS() {
    // load location map details
    if ($('#map-contact').length) {
        $.getScript("/js/utils/gmap.js", function(data, textStatus, jqxhr) {});
    }

    // load branch location map details
    if ($('#map-branch-location').length) {
        $.getScript("/js/utils/gmap.js", function(data, textStatus, jqxhr) {});
    }

    if ($('#listing-details').length) {
        const backEl = $('#backToSearch');
        let currentHistory = parseInt(localStorage.getItem('searchHistory'));
        let jsHistory = currentHistory * -1;
        backEl.attr('href', 'javascript:history.go(' + jsHistory + ')').removeClass('hidden');

        $(document).on('click', '#prevVehicle, #nextVehicle', function(e) {
            e.preventDefault();
            let href;
            localStorage.setItem('searchHistory', currentHistory + 1);
            if (e.target.id == 'nextVehicle' || e.target.id == 'prevVehicle') {
                href = e.target.href;
            } else {
                href = $(e.target).parent().attr('href');
            }
            window.location.href = href;
        });
    }

    // if (!$('#listing-details').length && !$('#vehicle-listings').length) {
    //     localStorage.removeItem('currentReferrer');
    // }

    // Validate AJAX form submit
    // ----------------------------------------------
    $(".form-ajax:not(.form-autosave)").each(function() {

        const rules = validateAjaxPhoneNumber($(this));

        // attach to all form elements on page
        $(this).validate({
            ignore: "",
            invalidHandler: function(event, validator) {},
            errorClass: "has-error help-block",
            validClass: "has-success",
            errorElement: "span",
            rules: rules,
            errorPlacement: function(error, element) {
                if ($(element).is('select')) {
                    element.next().after(error); // special placement for select elements
                    // }else if ( $(element).is('.dob') ) {
                    //     element.parent().after(error); // special placement for datepicker
                } else {
                    error.insertAfter(element); // default placement for everything else
                }
            },
            highlight: function(element, errorClass, validClass) {
                $(element).parents("div.form-group").addClass("has-error"); //.removeClass(validClass);j
            },
            unhighlight: function(element, errorClass, validClass) {
                // $(element).parents('.control-group').removeClass('error');
                $(element).parents(".has-error").removeClass("has-error");
            },
            submitHandler: function(form) {
                //$(form).find('.control-group').removeClass('success');
                submitAjaxForm(form);
            }
        });
    });

    // Weekly Specials signup
    // if ($("#frm-notifications").length || $('.form-weeklyspecials')) {
    //     $.validator.addMethod('require_one', function(value) {
    //         return $('.require_one:checked').size() > 0;
    //     }, 'Please check at least one branch');

    //     var checkboxes = $('.require_one');
    //     var checkbox_names = $.map(checkboxes, function(e, i) { return $(e).attr("name") }).join(" ");

    //     $('.form-weeklyspecials').validate({
    //         ignore: ".ignore",
    //         rules: {
    //             hiddenRecaptcha: {
    //                 required: function () {
    //                     if (grecaptcha.getResponse() == '') {
    //                         return true;
    //                     } else {
    //                         return false;
    //                     }
    //                 }
    //             }
    //         },
    //         groups: { checks: checkbox_names },
    //         errorContainer: "#signup-error",
    //         errorLabelContainer: "#signup-error ul",
    //         wrapper: "li",
    //         invalidHandler: function(event, validator) {
    //             $("#signup-error ul").addClass('alert alert-danger');
    //             console.log('invalidHandler');
    //         },
    //         highlight: function(element, errorLabelContainer, errorClass) {
    //             // $("#signup-error ul").addClass('alert alert-error');
    //             console.log('highlight');
    //         },
    //         unhighlight: function(element, errorLabelContainer, errorClass) {
    //             // $("#signup-error ul").removeClass("alert alert-error");
    //             console.log('unhighlight');
    //         },
    //         messages: {
    //             firstname: {
    //                 required: "Please enter your first name"
    //             },
    //             lastname: {
    //                 required: "Please enter your last name"
    //             },
    //             email: {
    //                 required: "Please enter your email",
    //                 email: "Please enter a valid email"
    //             },
    //             require_one: "Please check at least one branch",
    //             hiddenRecaptcha: 'Please tick the reCAPTCHA checkbox'
    //         },
    //         submitHandler: function(form) {

    //             processFormSubmitBtn($(form) );

    //             // console.log($(form).data('action'));

    //             // get the action url and submit the form
    //             $(form).prop('action', $(form).data('action') );

    //             // Form Submit
    //             form.submit();

    //         }

    //     });
    // }
    // END: Weekly Specials signup

    // validate weekly specials signup recaptcha callback
    // function recaptchaCallback() {
    //     $('#hiddenRecaptcha').valid();
    // };

    // prevent scrolling to listing until after append
    function goStockHash(removeHash) {
        const stockHash = window.location.hash;
        $('.search-listing').removeClass('hidden');
        if (stockHash.includes('searchListing_')) {
            let id = stockHash.split('searchListing_').pop();
            const element = document.getElementById('searchListing_' + id);
            if (element) {
                element.scrollIntoView({
                    behavior: 'instant'
                });
                let yOffset;
                if (window.innerWidth < 992) {
                    yOffset = -84;
                } else {
                    yOffset = -150;
                }
                window.scrollBy(0, yOffset);
            }
            if (removeHash) {
                window.history.replaceState({}, null,  window.location.pathname + window.location.search);
            }
        }
        $('.searchListing_skeleton').addClass('hidden').removeClass('visible-xl visible-xxl');
    }
}